import { BaseModel } from 'projects/core/src/lib/models/base.model';

export class ReportModel extends BaseModel {

  public_name: string;
  status: string;
  internal: boolean;
  can_finish: boolean;

}
